export default __webpack_public_path__ + "static/media/close.149a313d.svg";